import React, { useRef } from "react";
import styled from "styled-components";
import { BiLinkExternal } from "react-icons/bi";
import { FaGithub, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { motion } from "framer-motion";
import resume from "../assets/dummy.pdf";
import TerminalBox from "../components/TerminalBox";
import AnimatedHeadline from "../components/AnimatedHeadline";

const Home = () => {
  const backgroundRef = useRef(null);

  // useEffect(() => {
  //   const handleMouseMove = (e) => {
  //     if (!backgroundRef.current) return;

  //     const moveX = (e.clientX / window.innerWidth) * 15;
  //     const moveY = (e.clientY / window.innerHeight) * 15;

  //     backgroundRef.current.style.transform = `translate(${-moveX}px, ${-moveY}px)`;
  //   };

  //   window.addEventListener('mousemove', handleMouseMove);

  //   return () => {
  //     window.removeEventListener('mousemove', handleMouseMove);
  //   };
  // }, []);

  const socialLinks = [
    { icon: <FaGithub />, url: "https://github.com/mixmaker", label: "GitHub" },
    { icon: <FaLinkedinIn />, url: "https://www.linkedin.com/in/shoumik-kumbhakar-06a195225", label: "LinkedIn" },
    { icon: <FaTwitter />, url: "https://twitter.com/almost_shoumik", label: "Twitter" }
  ];

  return (
    <StyledHome>
      <div className="modern-background">
        <div className="noise-overlay"></div>
        <div className="gradient-mesh" ref={backgroundRef}>
          <div className="gradient-orb orb1"></div>
          <div className="gradient-orb orb2"></div>
        </div>
      </div>

      <div className="home-content container">
        <motion.div
          className="left-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >          <motion.div
            className="greeting"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.6, 
              delay: 0.2,
              type: "spring",
              stiffness: 50 
            }}
          >
            Hello, I'm
          </motion.div>

          <motion.h1
            className="name"
            initial={{ opacity: 0, scale: 0.95, filter: "blur(3px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ 
              duration: 0.8,
              delay: 0.3,
              type: "spring",
              damping: 12
            }}
          >
            Shoumik
          </motion.h1>
            <motion.div
            className="headline"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <motion.span 
              className="accent-gradient"
              initial={{ opacity: 0, y: 10, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.6, delay: 0.5, type: "spring", damping: 12 }}
            >
              Developer.
            </motion.span>{" "}
            <motion.span 
              className="role"
              initial={{ opacity: 0, y: 10, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.6, delay: 0.65, type: "spring", damping: 12 }}
            >
              Designer.
            </motion.span>{" "}
            <motion.span 
              className="accent-text"
              initial={{ opacity: 0, y: 10, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.6, delay: 0.8, type: "spring", damping: 12 }}
            >
              Creator.
            </motion.span>
          </motion.div>
          
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 0.7, 
              delay: 0.7,
              type: "spring",
              stiffness: 40
            }}
          >
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ 
                duration: 0.8,
                delay: 0.9,
                ease: "easeOut"
              }}
            >
              As a skilled full-stack developer, I am dedicated to turning ideas into
              innovative web and mobile applications. Explore my latest projects
              showcasing my expertise in web, mobile, and backend development.
            </motion.p>
          </motion.div>

          <motion.div
            className="cta-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
          >
            <a className="primary-button" href={resume} download="resume" aria-label="Download Resume">
              <span>Resume</span>
              <BiLinkExternal />
            </a>
            <a
              className="secondary-button"
              href="#contact"
              aria-label="Contact Me"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contact Me
            </a>
          </motion.div>

          <motion.div
            className="social-links"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 1.1 }}
          >
            {socialLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.2 }}
              >
                {link.icon}
              </motion.a>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          className="right-content"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          {/* <div className="hero-image-container">
            <motion.img 
              src={heroImg} 
              alt="Shoumik - Frontend Developer" 
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            />
          </div> */}
          <TerminalBox />
        </motion.div>
      </div>

      <motion.div
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        <motion.div
          className="mouse"
          animate={{
            y: [0, 12, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            repeatType: "loop",
          }}
        >
          <div className="wheel"></div>
        </motion.div>
        <span>scroll</span>
      </motion.div>
    </StyledHome>
  );
};

const StyledHome = styled(motion.section)`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 7rem 0 2rem;
  overflow: hidden;
  
  .modern-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    overflow: hidden;
    
    .noise-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 250 250' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E");
      opacity: 0.02;
      mix-blend-mode: overlay;
      pointer-events: none;
    }
    
    .gradient-mesh {
      position: absolute;
      width: calc(100% + 30px);
      height: calc(100% + 30px);
      top: -15px;
      left: -15px;
      transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
      
      .gradient-orb {
        position: absolute;
        border-radius: 50%;
        filter: blur(100px);
      }
      
      .orb1 {
        top: 15%;
        left: 10%;
        width: 35vw;
        height: 35vw;
        max-width: 550px;
        max-height: 550px;
        background: radial-gradient(circle at center, rgba(74, 91, 239, 0.08) 0%, rgba(74, 91, 239, 0) 70%);
        animation: float1 25s infinite alternate ease-in-out;
      }
      
      .orb2 {
        bottom: 15%;
        right: 10%;
        width: 30vw;
        height: 30vw;
        max-width: 500px;
        max-height: 500px;
        background: radial-gradient(circle at center, rgba(97, 218, 251, 0.08) 0%, rgba(97, 218, 251, 0) 70%);
        animation: float2 32s infinite alternate-reverse ease-in-out;
      }
      
      @keyframes float1 {
        0% {
          transform: translate(0, 0) scale(1);
        }
        100% {
          transform: translate(-30px, 20px) scale(0.95);
        }
      }
      
      @keyframes float2 {
        0% {
          transform: translate(0, 0) scale(0.95);
        }
        100% {
          transform: translate(30px, -20px) scale(1);
        }
      }
    }
  }
    .home-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5rem;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
    width: 100%;
  }
  
  .left-content {
    flex: 1;
    max-width: 550px;
    z-index: 1;
    
    .greeting {
      font-size: 1.15rem;
      font-weight: 500;
      color: var(--secondary-text);
      margin-bottom: 0.25rem;
      letter-spacing: 0.05em;
    }
    
    .name {
      font-size: 2.5rem;
      font-weight: 800;
      margin-bottom: 0.5rem;
      color: var(--primary-text);
      line-height: 1.1;
      letter-spacing: 0.05em;
    }      
    .headline {
      font-size: 3rem;
      font-weight: 700;
      margin-bottom: 1.75rem;
      line-height: 1.2;
      color: var(--heading-text);
      max-width: 100%;
      letter-spacing: -0.02em;
        .accent-gradient {
        background: linear-gradient(90deg, #4a5bef, #61DAFB);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: #4a5bef; /* Fallback color in case gradient text doesn't work */
        font-weight: 800;
      }
      
      .role {
        color: var(--primary-text);
        margin: 0 0.2rem;
      }
      
      .accent-text {
        color: var(--accent-color);
      }
    }
    
    .hero-text {
      margin-bottom: 2.5rem;
      position: relative;
      padding-left: 1rem;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 2px;
        background: linear-gradient(
          to bottom,
          var(--vibrant, #4a5bef) 0%,
          var(--accent-color, #61DAFB) 100%
        );
        opacity: 0.5;
      }
      
      p {
        color: var(--secondary-text);
        font-size: 1.05rem;
        line-height: 1.7;
        letter-spacing: 0.05em;
      }
    }      
    .cta-buttons {
      display: flex;
      gap: 1.5rem;
      margin-bottom: 2.5rem;
      flex-wrap: wrap;
        .primary-button, .secondary-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.7rem 1.5rem;
        border-radius: 2px;
        font-weight: 500;
        font-size: 0.85rem;
        letter-spacing: 0.02em;
        transition: all 0.2s ease;
      }
      
      .primary-button {
        background-color: transparent;
        color: var(--vibrant, #4a5bef);
        border: 1px solid var(--vibrant, #4a5bef);
        opacity: 0.85;
        
        &:hover {
          opacity: 1;
          transform: translateY(-1px);
          box-shadow: 0 2px 5px rgba(74, 91, 239, 0.1);
        }
        
        svg {
          font-size: 0.8rem;
          transition: transform 0.2s ease;
        }
        
        &:hover svg {
          transform: translateX(2px);
        }
      }
      
      .secondary-button {
        background-color: transparent;
        color: var(--secondary-text);
        border: 1px solid rgba(255, 255, 255, 0.08);
        
        &:hover {
          border-color: rgba(97, 218, 251, 0.2);
          color: var(--accent-color, #61DAFB);
          transform: translateY(-1px);
        }
      }
    }
    
    .social-links {
      display: flex;
      gap: 1.75rem;
      
      a {
        color: var(--secondary-text);
        font-size: 1.2rem;
        transition: all 0.3s ease;
        
        &:hover {
          color: var(--vibrant);
          transform: translateY(-5px);
        }
      }
    }
  }
    .right-content {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    max-width: 500px;
    
    .hero-image-container {
      position: relative;
      width: 100%;
      max-width: 450px;
      
      img {
        width: 100%;
        height: auto;
        position: relative;
        border-radius: 4px;
        object-fit: cover;
        transition: all 0.3s ease;
      }
    }
  }

  .scroll-indicator {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    
    .mouse {
      width: 24px;
      height: 40px;
      border: 1px solid var(--vibrant);
      opacity: 0.6;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      padding-top: 8px;
      
      .wheel {
        width: 3px;
        height: 8px;
        background: linear-gradient(
          to bottom,
          var(--vibrant, #4a5bef) 0%,
          var(--accent-color, #61DAFB) 100%
        );
        border-radius: 2px;
      }
    }
    
    span {
      font-size: 0.75rem;
      color: var(--vibrant);
      opacity: 0.8;
      letter-spacing: 0.15em;
      font-weight: 400;
    }
  }
  
  @media only screen and (max-width: 1100px) {
    // ...existing code...
  }
    @media only screen and (max-width: 1200px) {
    .home-content {
      gap: 3rem;
    }
  }

  @media only screen and (max-width: 992px) {
    padding-top: 6rem;
    
    .home-content {
      flex-direction: column;
      text-align: center;
      gap: 4rem;
      padding: 0 1.5rem;
    }
    
    .left-content {
      order: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 100%;
      
      .hero-text {
        padding-left: 0;
        max-width: 600px;
        
        &::before {
          display: none;
        }
      }
      
      .cta-buttons {
        justify-content: center;
      }
      
      .social-links {
        justify-content: center;
      }
    }
    
    .right-content {
      order: 1;
      margin-bottom: 1rem;
      justify-content: center;
      max-width: 100%;
    }
  }
  
  @media only screen and (max-width: 576px) {
    // ...existing code...
  }
`;

export default Home;
